export function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    if (!src) {
      reject(new Error('empty'))
      return
    }
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error('img'))
    img.src = src
  })
}

export function drawCover(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  w: number,
  h: number,
): void {
  const ir = img.width / img.height
  const r = w / h
  let dw: number
  let dh: number
  let dx: number
  let dy: number
  if (ir > r) {
    dh = h
    dw = img.width * (h / img.height)
    dx = (w - dw) / 2
    dy = 0
  } else {
    dw = w
    dh = img.height * (w / img.width)
    dx = 0
    dy = (h - dh) / 2
  }
  ctx.drawImage(img, dx, dy, dw, dh)
}

export function canvasToPngBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    if (!canvas.toBlob) {
      reject(new Error('toBlob'))
      return
    }
    canvas.toBlob((blob) => {
      if (blob) resolve(blob)
      else reject(new Error('blob'))
    }, 'image/png')
  })
}

export function downloadBlob(blob: Blob, filename = 'eu-apoio.png'): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 1500)
}
